// extracted by mini-css-extract-plugin
export var closeButton = "_1h-1";
export var container = "_1h-0";
export var fullModalImage = "_1h-2";